import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { LocalStorageKey } from '~/constants/localstorage'
import store from '~/store'

export const AvailableLanguages = [
  { label: 'English', value: 'en' },
  { label: '简体中文', value: 'zh-CN' },
  { label: '繁體中文', value: 'zh-TW' },
  { label: '한국어', value: 'ko-KR' },
  { label: 'Norsk', value: 'no' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Italiano', value: 'it' },
  { label: 'Português', value: 'pt' },
  { label: 'Español', value: 'es' },
  { label: 'Türkçe', value: 'tr' }
]

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({ 
    fallbackLng: 'en',
    lng: 'en'
  })
  .then(() => {
    const settingLanguage = store.getState().settings.language

    if (settingLanguage && AvailableLanguages.some(lang => settingLanguage === lang.value)) {
      i18n.changeLanguage(settingLanguage)
      return
    }

    if (settingLanguage && !AvailableLanguages.some(lang => settingLanguage === lang.value)) {
      localStorage.setItem(LocalStorageKey.LANGUAGE, 'en')
      i18n.changeLanguage('en')
      return
    }

    if (!settingLanguage) {
      localStorage.setItem(LocalStorageKey.LANGUAGE, 'en')
      i18n.changeLanguage('en')
    }
  })

export default i18n
